import { FALLBACK_IMAGE } from "./constants";

export const fallbackImage = event => {
  event.target.onerror = null;
  event.target.src = FALLBACK_IMAGE;
};
